import { useContext } from 'react';
import type { IAddableServiceGroupServiceRights } from '@common/interfaces';
import { CareProviderAddRightsContext } from '../careProviderAddRightsContext';
import { ServiceEmploymentSettings } from '../settings/serviceEmploymentSettings';

export interface IAddServiceEmploymentSettingsProps {
    addableServiceGroupServiceRights: IAddableServiceGroupServiceRights;
}

export function AddServiceEmploymentSettings(props: IAddServiceEmploymentSettingsProps) {
    const { addableServiceGroupServiceRights } = props;
    const { addRightsState } = useContext(CareProviderAddRightsContext);

    return (
        <>{addRightsState.serviceEmploymentActivities.map((service) => renderServiceEmploymentSettings(service.id))} </>
    );

    function renderServiceEmploymentSettings(serviceId: string) {
        const serviceEmploymentToAdd = addableServiceGroupServiceRights.serviceEmploymentServices.filter(
            (serviceEmployment) => serviceEmployment.id === serviceId
        )[0];

        if (serviceEmploymentToAdd) {
            return (
                <ServiceEmploymentSettings
                    key={`serviceEmployment-${serviceEmploymentToAdd.id}`}
                    service={serviceEmploymentToAdd}
                />
            );
        }
    }
}
